import { BASE_URL_CGI_GO } from '../../base/constants/cgi-base';
// 增加一个At人记录
export var MENTION_ADD = "".concat(BASE_URL_CGI_GO, "mention/mention_add");
// 删除一个At人记录
export var MENTION_DEL = "".concat(BASE_URL_CGI_GO, "mention/mention_del");
// 获取文档的At人列表
export var GET_DOC_MENTION_LIST = "".concat(BASE_URL_CGI_GO, "mention/get_doc_mention_list");
// 获取我的At人列表
export var GET_MY_MENTION_LIST = "".concat(BASE_URL_CGI_GO, "mention/get_my_mention_list");
// 发请求标志所有本次 At我的信息 已读
export var MENTION_READ_REPORT = "".concat(BASE_URL_CGI_GO, "mention/mention_read_report");
